import React, { useEffect, useRef, useState } from 'react';
import {
  CurrencyUpgradeSelector,
  DisclaimerText
} from '@common/components/upgradeJobAd';
import { useFetchJobData } from '@common/hooks/job';
import { AD_TYPE } from '@seek/je-shared-data';
import { EnhancedJobProps } from '../types';
import {
  EnhanceFormData,
  EnhanceFormRef,
  EnhanceJobForm
} from './EnhanceJobForm';

export type OnSubmitValues = EnhanceFormData & {
  adType: AD_TYPE;
};

type DefaultValues = Partial<EnhanceFormData> | undefined;
export type Props = EnhancedJobProps<OnSubmitValues, DefaultValues>;

export const EnhanceJob = (props: Props) => {
  const {
    jobCountryCode,
    defaultValues,
    onSubmit,
    onBack,
    onNext,
    onChangeAdType,
    selectedAdType,
    onNextText,
    hideBackButton,
    hideBasicAdType = false,
    disableSelector = false,
    businessId,
    jobId
  } = props;
  const { data: jobData } = useFetchJobData({
    jobId
  });
  const [adType, setAdType] = useState<AD_TYPE>(selectedAdType || AD_TYPE.PLUS);

  const formRef = useRef<EnhanceFormRef | null>(null);

  useEffect(() => {
    onChangeAdType(adType);
  }, [adType]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSelectorChange = (selected: AD_TYPE) => {
    setAdType(selected);
    formRef.current?.clearErrors();

    if (selected === AD_TYPE.BASIC) {
      formRef.current?.resetFormValues({
        rightToWork: null,
        immediateStart: null,
        videoScreeningQuestion: null
      } as any);
    }
  };

  return (
    <div className="flex flex-col gap-lg">
      <CurrencyUpgradeSelector
        value={adType}
        onChange={onSelectorChange}
        jobCountryCode={jobCountryCode}
        disabled={disableSelector}
        showBasicAdType={!hideBasicAdType}
      />

      <EnhanceJobForm
        ref={formRef}
        jobCountryCode={jobCountryCode}
        disabled={adType === AD_TYPE.BASIC}
        onBack={onBack}
        onNext={onNext}
        onNextText={onNextText}
        hideBackButton={hideBackButton}
        onSubmit={(values) => onSubmit(values && { ...values, adType })}
        defaultValues={defaultValues}
        businessId={businessId}
        currentAdType={jobData?.adType}
      />

      <DisclaimerText jobCountryCode={jobCountryCode} />
    </div>
  );
};
